module.exports = __webpack_public_path__ + "img/花椒.bfb8a534.jpg";